import palette from '../palette';

const muiListItemIconOverrides = {
  styleOverrides: {
    root: {
      color: palette.text.secondary,
      minWidth: '32px',
    },
  },
};

export default muiListItemIconOverrides;
